import React from "react";
import { concatClassnames } from "shared/utils/concatClassnames";

const HEADING_LEVEL_MAPS: Record<string, string> = {
  h1: "gg-text-3xl sm:gg-text-4xl md:gg-text-7xl gg-leading-10 gg-font-bold",
  h2: "gg-text-1.5xl gg-leading-8 gg-font-bold",
  h3: "gg-text-xl gg-font-bold",
  h4: "gg-text-lg gg-font-bold",
  h5: "gg-text-base gg-font-bold",
  h6: "gg-text-sm",
};

interface HeadingProps {
  children: any;
  headingLevel: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
  className?: string;
}
const Heading = ({ children, headingLevel, className }: HeadingProps) => {
  const Element = ({ ...props }: React.HTMLAttributes<HTMLHeadingElement>) =>
    React.createElement(headingLevel, props, children);

  return (
    <>
      <Element
        className={concatClassnames(
          "gg-text-primary-color",
          HEADING_LEVEL_MAPS[headingLevel],
          className
        )}
      >
        {children}
      </Element>
    </>
  );
};
export default Heading;
